import angular from 'angular';
import 'angular-sanitize';
import ProjectSelectorComponent from './project-selector.component';


const projectSelector = angular.module('ttb.widgets.projectSelector', [
    'ttb.services',
    'ui.select',
    'ngSanitize',
    'ttb.directives',
])
    .component('projectSelector', ProjectSelectorComponent)
    .name;

export default projectSelector;



// WEBPACK FOOTER //
// ../widgets/project-selector/index.js